export const FOODIE_REQUEST = {
    ADMIN_ACTIVE:  1,
    HISTORY_ACTIVE:  2,
    USER_ACTIVE:  3,
    USER_HISTORY:  4,
}
